<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <span class="">
    <Icon name="ph:spinner-gap" class="animate-spin" size="2em" />
  </span>
</template>
